import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { selectWebsiteTheme } from "../../../../store/slices/website";
import CLModal from "../../../../components/CLModal";
import CLButton from "../../../../components/CLButton";
import CLDate from "../../../../components/CLDate";
import CLTime from "../../../../components/CLTime";

import { EventDetails } from "./styled";

const CalendarEventModal = ({ calendarEvent, isVisible, onClose }) => {
  const { t } = useTranslation();
  const { colors } = useSelector(selectWebsiteTheme);
  const sourceEvent = calendarEvent?.extendedProps?.source_event

  const renderContent = () => {
    if (!sourceEvent) {
      return;
    }

    return (
      <EventDetails colors={colors}>
        <div className="event-info">
          <span className="event-info__text">
            <CLDate date={sourceEvent.event_date} />
          </span>
          <div className="event-info__dot"></div>

          {sourceEvent.is_all_day ? (
            <span className="event-info__text">All-day</span>
          ) : (
            <span className="event-info__text">
              <CLTime date={calendarEvent.start} />
              {" - "}
              <CLTime date={calendarEvent.end} />
            </span>
          )}
          {sourceEvent.is_recurring && (
            <>
              <div className="event-info__dot"></div>
              <span className="event-info__text">Recurring</span>
            </>
          )}
        </div>
        <div className="event-description">
          {sourceEvent.description ? (
            <span className="event-description__content">
              {sourceEvent.description}
            </span>
          ) : (
            <span className="event-description__empty-message">
              No description
            </span>
          )}
        </div>

        {/* {renderRelations()} */}
      </EventDetails>
    );
  };

  const renderFooter = () => {
    return (
      <>
        <CLButton primary onClick={onClose}>
          {t("close", "Close")}
        </CLButton>
      </>
    );
  };

  return (
    <CLModal
      isVisible={isVisible}
      onClose={onClose}
      title={calendarEvent?.title}
      renderContent={renderContent}
      renderFooter={renderFooter}
    />
  );
};

CalendarEventModal.propTypes = {
  calendarEvent: PropTypes.object.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CalendarEventModal;


// const renderRelations = () => {
//   if (
//     !sourceEvent.event_properties?.length &&
//     !sourceEvent.users?.length &&
//     !sourceEvent.association
//   ) {
//     return null;
//   }

//   return (
//     <>
//       <CLSeparator />
//       <div className="event-relations">
//         <h4 className="event-relations__title">Association</h4>
//         <ul className="event-relations__list">
//           <li>{sourceEvent.association.name}</li>
//         </ul>
//       </div>
//       <div className="event-relations">
//         <h4 className="event-relations__title">
//           Associated People ({sourceEvent.users?.length})
//         </h4>
//         <ul className="event-relations__list">
//           {sourceEvent.users.map((user) => (
//             <li key={user.user_id}>{user.display_name}</li>
//           ))}
//         </ul>
//       </div>
//       <div className="event-relations">
//         <h4 className="event-relations__title">
//           Associated Properties ({sourceEvent.event_properties?.length})
//         </h4>
//         <ul className="event-relations__list">
//           {sourceEvent.event_properties.map((property) => (
//             <li key={property.property_id}>{property.display_name}</li>
//           ))}
//         </ul>
//       </div>
//     </>
//   );
// };